import { Icon } from '../../icons/Icon.component';

export const NotificationCloseIcon = () => <Icon size={14} icon={'xmark-regular'} />;
